document.addEventListener('submit', async (e) => {
  const form = e.target.closest('.io-contact__form');
  if (!form) return;

  e.preventDefault();

  const section = form.closest('.io-contact');
  const webhook = section.dataset.webhook;
  const status = form.querySelector('.io-contact__status');

  const data = Object.fromEntries(new FormData(form).entries());

  status.hidden = false;
  status.textContent = 'Sending…';

  try {
    const res = await fetch(webhook, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });

    if (!res.ok) throw new Error('Request failed');

    form.reset();
    status.textContent = 'Thanks — our team will be in touch shortly.';
  } catch (err) {
    status.textContent = 'Something went wrong. Please try again.';
  }
});
